import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class MstSubDepartmentService {
    mstSubDepartment: any;
    private headers = new Headers({'Content-Type': 'application/json'});
    private ListRecord = webapi + 'mst_sub_department/list/?';
    private DeListRecord = webapi + 'mst_sub_department/deactiveList/?';
    private ListRecordByDepartmentId = webapi + 'mst_sub_department/listByDepartment/?';
    private AddRecord = webapi + 'mst_sub_department/create';
    private EditRecord = webapi + 'mst_sub_department/update';
    private GetRecord = webapi + 'mst_sub_department/byid/';
    private GetRecordbydepartment = webapi + 'mst_sub_department/bydepartment/';
    private GetRecordbydepartmentUnitId = webapi + 'mst_sub_department/subDepartmentbyunitid/';
    private DeleteRecord = webapi + 'mst_sub_department/delete/';
    private GetRecordbydepartmentByUnitId = webapi + 'mst_sub_department/subDepartmentbyunitid/';
    private GetDropDown = webapi + 'mst_sub_department/dropdown?';
    private ReActiveRecord = webapi + 'mst_sub_department/reActive/';

    constructor(
        private http: Http
    ) {
    }

    getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllRecordServiceByDepartment(currentPage: any, size: any, departmentId: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.ListRecordByDepartmentId + 'page=' + currentPage + '&size=' + size + '&qString=' + departmentId + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllDeactivatedRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.DeListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    addRecordService(model: any) {
        return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    editRecordService(model: any) {
        return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    deleteRecordService(id: any) {
        return this.http.put(this.DeleteRecord + id, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    reActiveRecordService(id: any) {
        return this.http.put(this.ReActiveRecord + id, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRecordService(id: any) {
        return this.http.get(this.GetRecord + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getbydepartment(id: any) {
        return this.http.get(this.GetRecordbydepartment + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getbydepartmentUnitId(id: any, unitId: any) {
        return this.http.get(this.GetRecordbydepartmentUnitId + id + '/' + unitId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllDropDown(currentPage: any, size: any, globalFilter: any, departmentList: any): Promise<any> {
        // console.log(this.GetDropDown + 'page=' + currentPage + '&size=' + size + '&globalFilter=' + globalFilter + '&departmentList=' + departmentList);
        return this.http.get(this.GetDropDown + 'page=' + currentPage + '&size=' + size + '&globalFilter=' + globalFilter + '&departmentList=' + departmentList)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getbydepartmentByUnitId(id: any, unitId: any) {
        return this.http.get(this.GetRecordbydepartmentByUnitId + id + '/' + unitId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    private handleError(error: Response | any) {
        return Promise.reject(error.message || error);
    }
}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/mst-sub-department/mst-sub-department.service.ts